
import styles from './style.module.css'

// Creator : Team A - Amos
function QuestionBoard({ result, question, saveAnswer, index }) {
    const isActive1 = result.find(a => a.orderNum === question.orderNum)

    return (
        <div className={`${styles.QuestionBoard} two-colored-div`}>

            <div className={styles.QuestionBoardText}>
                <p className={styles.questionInd} >{index + 1 + "/10 "}</p>
                <p>{question.title}</p>
            </div>
            <div className={styles.buttons}>
                <button onClick={() => saveAnswer(question.orderNum, true, question._id)} className={`${isActive1 && isActive1.answer === true ? styles.active : null}`}>TRUE
                </button>
                <button onClick={() => saveAnswer(question.orderNum, false, question._id)} className={`${isActive1 && isActive1.answer === false ? styles.active : null}`}>FALSE
                </button>
            </div>
        </div>)
}


export default QuestionBoard